module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "main-dialog",
    attrs: {
      "title": undefined,
      "show-close": false,
      "visible": _vm.visible,
      "width": _vm.isDesktop ? '60%' : '90%',
      "before-close": _vm.onCloseSettings
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "1em",
      "color": "black"
    }
  }, [_vm._v("COVID-19 STATEMENT")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Thanks for stopping by the BOSS!  We are eager to host the 15th Annual Boss Hog Cook-Off (BHC); however, we understand that we are living in uncertain times.  The health and safety of our community, teams, judges, and volunteers remain our top priority; therefore, we are closely monitoring the ever-changing news and spread of COVID-19, and will make decisions and update as needed…  Check our social media (Facebook & Instagram) for any and all updates.\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px",
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Our desire is to bring back this community favored event, even with mask-covered smiles, air hugs, and air high-fives.  Hope to see you at the BOSS in Waynesboro, GA on May 14th & 15th!\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px",
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Your BHC Crew,"), _c('br'), _vm._v("\n        Lindsey Beazley Keller, Nan Palmer Lynch, Elizabeth Billips, & Tim Lively\n      ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbde1efc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainDialog.vue
// module id = 938
// module chunks = 1